// @flow
import styles from './busy-overlay.component.module.styl';

export const CSS_OVERLAY_ANIMATION_TIME = 300;
export const BUSY_OVERLAY: 'busy-overlay' = 'busy-overlay';
export const RENDER_OVERLAY_CUSTOM_EVENT = 'renderOverlayCustomEvent';
export const HIDE_SCROLLBAR: string = styles['hide-scrollbar'];
